.root {
  width: 100%;
  border-radius: 0;
}

@media (min-width: 900px) {
  .root {
    border-radius: 4px;
  }
}

.root.transparent {
  box-shadow: none;
  background-color: transparent;
}

.withoutPadding {
  padding: 0 !important;
}

@media (min-width: 900px) {
  .desktopWithoutPadding {
    padding: 0 !important;
  }
}

/* On paper the elevation reads as a smudge, not depth. */
@media print {
  .root {
    box-shadow: none !important;
    break-inside: avoid;
  }
}
